import { createApp, h, DefineComponent } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { ZiggyVue } from 'ziggy-js';
import DefaultLayout from '@/Layouts/Default.vue';
import {DayJsPlugin} from "@/Plugins/DayJsPlugin";

createInertiaApp({
    resolve: name => {
        const pages = import.meta.glob<true, string, DefineComponent>('./Pages/**/*.vue', { eager: true });
        let page = pages[`./Pages/${name}.vue`];
        page.default.layout = page.default.layout || DefaultLayout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) });
            app.use(plugin)
            .use(ZiggyVue)
            .use(DayJsPlugin)
            .mount(el);
    },
});
